// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".19fc9786b4f391f895521a8c8d6692dfb27d5e4d.chunk.js";
};